import { render, staticRenderFns } from "./TypeDocumentSelect.vue?vue&type=template&id=33de1a79&"
import script from "./TypeDocumentSelect.vue?vue&type=script&lang=js&"
export * from "./TypeDocumentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports